<div>
  <app-list-user-accords *ngIf="loaded" [accordsArray]="accords"></app-list-user-accords>
</div>
